const getUserMessages = function getUserMessages(errors) { // eslint-disable-line
  // TODO create helper function to derive messages from errors

  return {
    headline: 'Something’s broken right now - we’re working on a fix',
    message: 'In the meantime, try refreshing the page or check back later.',
  };
};

export default getUserMessages;
